import { createAction, props } from '@ngrx/store';
import { Resource, ResourceResponceDTO } from './models';

export const fetchResourceItemsByCourse = createAction(
  '[Resource API] Fetch Resource Items By Course',
  props<{ courseId: string }>()
);

export const pollResourceItemsByCourse = createAction(
  '[Resource API] Poll Resource Items By Course',
  props<{ courseId: string }>()
);

export const stopPollingResourceItem = createAction(
  '[Resource API] Stop Resource Item Polling'
);

export const fetchResourceItemsSuccess = createAction(
  '[Resource API] Fetch Resource Items Success',
  props<{ resourceResponse: ResourceResponceDTO }>()
);

export const fetchResourceItemsFailed = createAction(
  '[Resource API] Fetch Resource Items Failed',
  props<{ error: any }>()
);

export const uploadUrlResource = createAction(
  '[Resource API] Upload URL Resource',
  props<{ name: string; url: string; resourceType: string; courseId?: string }>()
);

export const uploadUrlResourceSuccess = createAction(
  '[Resource API] Upload URL Resource Success',
  props<{ resourceId: string }>()
);

export const uploadUrlResourceFailed = createAction(
  '[Resource API] Upload URL Resource Failed',
  props<{ error: any }>()
);

export const pollSingleResourceStatus = createAction(
  '[Resource API] Poll Single Resource Status',
  props<{ resourceId: string }>()
);

export const stopPollingSingleResource = createAction(
  '[Resource API] Stop Polling Single Resource',
  props<{ resourceId: string }>()
);

export const singleResourceStatusUpdated = createAction(
  '[Resource API] Single Resource Status Updated',
  props<{ resource: Resource }>()
);
